
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/tools/funnel-generator",
      function () {
        return require("private-next-pages/site/tools/funnel-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/tools/funnel-generator"])
      });
    }
  